export const navigation = [
  { name: '首页', href: '/', icon: 'ri-home-4-line' },
  { name: '功能指南', href: '/category/feature-guide', icon: 'ri-guide-line' },
  { name: '使用教程', href: '/category/tutorial', icon: 'ri-book-open-line' },
  { name: '最新动态', href: '/category/news', icon: 'ri-newspaper-line' },
  { name: '常见问题', href: '/category/faq', icon: 'ri-question-answer-line' },
  { name: '关于我们', href: '/about', icon: 'ri-information-line' },
];